class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#SearchDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderSearchIconAccessibility();
  }

  setHeaderSearchIconAccessibility() {
    // Select all search link elements with the class .search-icon-notification
    const searchLinks = document.querySelectorAll(".search-icon-notification");

    // Iterate over each search link and apply the attributes and event listeners
    searchLinks.forEach((searchLink) => {
      searchLink.setAttribute("role", "button");
      searchLink.setAttribute("aria-haspopup", "dialog");

      searchLink.addEventListener("click", (event) => {
        event.preventDefault();
        const containerToTrapFocusOn = document.getElementById("SearchDrawer");
        trapFocus(
          containerToTrapFocusOn,
          containerToTrapFocusOn.querySelector('input:not([type="hidden"])')
        );
        this.open(searchLink);
      });

      searchLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          const containerToTrapFocusOn = document.getElementById("SearchDrawer");
          trapFocus(
            containerToTrapFocusOn,
            containerToTrapFocusOn.querySelector('input:not([type="hidden"])')
          );
          this.open(searchLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    publish(PUB_SUB_EVENTS.closeAllHeader, { source: "search-drawer" });

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#SearchDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "search-drawer",
        selector: "#SearchDrawer",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("search-drawer", SearchDrawer);
